import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../api';
import AuthLayout from '../components/AuthLayout';
import FormField  from '../components/FormField';
import Button     from '../components/Button';
import Alert      from '../components/Alert';

export default function Confirm() {
  const [params]    = useSearchParams();
  const navigate    = useNavigate();
  const token       = params.get('token') || '';
  const [valid, setValid]   = useState(null);
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ username: '', password: '', confirm_password: '' });

  useEffect(() => {
    if (!token) { setValid(false); setError('No token provided'); return; }
    api.post('/auth/confirm', { token })
      .then(() => setValid(true))
      .catch(e => { setValid(false); setError(e.response?.data?.error || 'Invalid token'); });
  }, [token]);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.post('/auth/confirm/complete', { ...form, token });
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to complete registration');
    } finally {
      setLoading(false);
    }
  };

  if (valid === null) return <AuthLayout title="Verifying..."><p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>Checking your token...</p></AuthLayout>;
  if (!valid) return <AuthLayout title="Invalid link"><Alert>{error}</Alert></AuthLayout>;

  return (
    <AuthLayout title="Almost there" subtitle="Choose your username and password">
      <form onSubmit={submit}>
        {error && <Alert>{error}</Alert>}
        <FormField label="Username" name="username" value={form.username} onChange={handle} required />
        <FormField label="Password" name="password" type="password" value={form.password} onChange={handle} required />
        <FormField label="Confirm password" name="confirm_password" type="password" value={form.confirm_password} onChange={handle} required />
        <Button loading={loading} type="submit" style={{ marginTop: '8px' }}>Complete registration</Button>
      </form>
    </AuthLayout>
  );
}
